export default "__VITE_ASSET__C01Iatr6__"